/* 2026-09-04 — cart fixes applied by Claude on unpublished theme copy.
 * This same source is deployed as BOTH custom-features.js.liquid and custom-new-features.js.liquid so
 * every page runs identical, working cart code. Previously custom-new-features.js
 * (loaded on /collections/*) called setQuickAddListener() after the function had been
 * commented out -> ReferenceError -> all cart JS on collection pages aborted.
 * Search "2026-09-04 fix" for each change. Originals: live theme "Best Sellers image fix - 2026-08-07".
 */
$(function () {
  /**
   * Works on home page. Fetches new products and shuffles them.
   */
  function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }
  //Cookie name, value, expires in days
  function setCookie(e, t, r) {
    var o,
      i = '';
    r &&
      ((o = new Date()).setTime(o.getTime() + 24 * r * 60 * 60 * 1e3),
      (i = '; expires=' + o.toUTCString())),
      (document.cookie = e + '=' + (t || '') + i + '; path=/');
  }

  //Cookie name
  function getCookie(e) {
    for (
      var t = e + '=', o = document.cookie.split(';'), r = 0;
      r < o.length;
      r++
    ) {
      for (var i = o[r]; ' ' == i.charAt(0); ) i = i.substring(1, i.length);
      if (0 == i.indexOf(t)) return i.substring(t.length, i.length);
    }
    return null;
  }

  var fetchedProducts = [];
  var page = 0;

  function fetchProducts(pagination, renderCallback) {
    fetch('/products.json?limit=250&page=' + pagination)
      .then((response) => response.json())
      .then((result) => {
        let mappedFilteredProducts = result['products']
          .map((product) => {
            try {
              var imgUrlArr = product.images
                ? product.images[0].src.split('?')
                : product.featured_image.split('?');

              var imgUrl =
                imgUrlArr[0].slice(0, -4) +
                '_300x' +
                imgUrlArr[0].slice(-4) +
                (imgUrlArr[1] ? '?' + imgUrlArr[1] : '');
            } catch (err) {
              var imgUrl = '';
            }

            var mappedProduct = {
              title: product.title,
              handle: product.handle,
              image: imgUrl,
            };

            product.variants.forEach((variant) => {
              mappedProduct[variant.title.toLowerCase()] = variant.id;
              // 2026-09-04 fix: products now have two options (Print Size / Material),
              // so variant titles are "Small / Sticker" etc. QuickAdd needs
              // mappedProduct.small / .large -> use the Sticker variant for each size.
              var size = (variant.option1 || '').toLowerCase();
              var material = (variant.option2 || '').toLowerCase();
              if (size && (material === 'sticker' || material === '' || !mappedProduct[size])) {
                mappedProduct[size] = variant.id;
              }
            });

            return mappedProduct;
          })
          .filter(
            (product) =>
              !(
                product.title.includes('Free') &&
                product.title.includes('Sided')
              )
          );
        fetchedProducts = [...fetchedProducts, ...mappedFilteredProducts];
        fetchedProducts = shuffleArray(fetchedProducts);
        renderCallback();
      });
  }

  $('#new-products .load-more').click(function () {
    $('#new-products .load-more').css('display', 'none');
    $('#new-products .sticker-loader').css('display', 'block');

    if (fetchedProducts.length < 1) {
      fetchProducts(1, renderNewProducts);
    } else {
      renderNewProducts();
    }
  });

  function renderNewProducts() {
    fetchedProducts.slice(page * 24, page * 24 + 24).forEach((product) => {
      var html =
        '  <div class="col-xs-12 thumbnail thumbnail-variant  four-per-row text-center">' +
        '<div id="quick-add-button"> <a class="icon-cart cart-button counter-hidden"></a><span></div>' +
        '<a href="/products/' +
        product.handle +
        '" data-variant-small="' +
        product.small +
        '" data-variant-large="' +
        product.large +
        '">' +
        '<img src="' +
        product.image +
        '"' +
        'alt=' +
        product.title +
        '/>' +
        '<p>' +
        product.title +
        '</p>' +
        '</a>' +
        '</div>';
      $('#new-products .new-products').append($(html));
    });
    $('#new-products .sticker-loader').css('display', 'none');
    if (page < 10) {
      $('#new-products .load-more').css('display', 'inline-block');
    }

    page++;
  }

  if ($('#new-products .load-more').length > 0) {
    $('#new-products .load-more')[0].click();
  }
  

  /**------------------------------------------------------------------------------------------------ */

  /**
   * Sets up quick add for cart.
   */
  function setQuickAddListener() {
    var handle;
    var currentlyOver;
    $('#new-products, .products').on(
      'mouseenter touchstart',
      '.thumbnail',
      function () {
        clearTimeout(handle);
        currentlyOver = $(this);
        console.log(currentlyOver);
        if (screen.width > 991) {
          currentlyOver.children('#quick-add-button').css('display', 'flex');
          handle = setTimeout(function () {
            currentlyOver.children('#quick-add-button').css('opacity', '1');
          }, 20);
        }
      }
    );
    $('#new-products, .products').on('mouseleave', '.thumbnail', function () {
      clearTimeout(handle);
      currentlyOver = null;
      $(this).find('>a').css('filter', 'none');
      if (screen.width > 991) {
        $(this).children('#quick-add-button').css('display', 'none');
        $(this).children('#quick-add-button').css('opacity', '0');
      } else {
        $(this).children('#quick-add-button').css('display', 'flex');
        $(this).children('#quick-add-button').css('opacity', '1');
      }

      $(this).append($('#quick-add'));
      $('#quick-add').css('opacity', '0');
      $('#quick-add').css('display', 'none');
    });

    $('#new-products, .products').on(
      'click',
      '#quick-add-button',
      function (event) {
        console.log('here');
        event.stopPropagation();
        currentlyOver.find('>a').css('filter', 'blur(8px)');

        currentlyOver.children('#quick-add-button').css('opacity', '0');
        currentlyOver.children('#quick-add-button').css('display', 'none');

        currentlyOver.prepend($('#quick-add'));
        $('#quick-add').css('display', 'block');

        handle = setTimeout(function () {
          $('#quick-add').css('opacity', '1');
        }, 20);
      }
    );

    $('.quick-add-options li').on('click', function (event) {
      event.stopPropagation();

      var variantQty = $(this).attr('data-id');
      var variantArr = variantQty.split('-');

      var qty = parseInt(variantArr[0]);

      var variantType = variantArr[1];

    // Get the small and large variant IDs using the appropriate attribute selectors
     var smallVariantAttr = 'data-variant-small';
     var largeVariantAttr = 'data-variant-large';

     // Get the small and large variant IDs from the element
     var smallVariantId = parseInt(currentlyOver.find('a[' + smallVariantAttr + ']').attr(smallVariantAttr));
     var largeVariantId = parseInt(currentlyOver.find('a[' + largeVariantAttr + ']').attr(largeVariantAttr));

     // Prepare the line item properties object
     var lineItemProperties = {};

     // Add small and large variant information to lineItemProperties
     lineItemProperties['Small Variant ID'] = smallVariantId;
     lineItemProperties['Large Variant ID'] = largeVariantId;
     lineItemProperties['Small Variant Name'] = 'Small';  // You can customize this if needed
     lineItemProperties['Large Variant Name'] = 'Large';  // You can customize this if needed
      
      var productAttr = 'data-variant-' + variantType;
    
      var variantId = parseInt(
        currentlyOver.find('a[' + productAttr + ']').attr(productAttr)
      );

      // 2026-09-04 fix: never POST id: NaN to /cart/add.js
      if (!variantId || isNaN(variantId)) {
        console.error('QuickAdd: no ' + variantType + ' variant id found for this product');
        alert('Sorry, this design could not be quick-added. Please open the design and add it from its page.');
        currentlyOver.find('>a').css('filter', 'none');
        $('#quick-add').css('opacity', '0');
        $('#quick-add').css('display', 'none');
        return;
      }

      currentlyOver.children('#quick-add-button').css('display', 'flex');
      handle = setTimeout(function () {
        currentlyOver.children('#quick-add-button').css('opacity', '1');
      }, 20);
      currentlyOver.find('>a').css('filter', 'none');
      $('#quick-add').css('opacity', '0');
      $('#quick-add').css('display', 'none');

      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        data: {
          form_type: 'product',
          id: variantId,
          'option-0': variantType,
          quantity: qty,
          properties: lineItemProperties
        },
        dataType: 'json',
      }).fail(function (xhr) {
        var msg = 'Could not add to cart.';
        try { msg = JSON.parse(xhr.responseText).description || msg; } catch (e) {}
        console.error('QuickAdd /cart/add.js failed', xhr.status, xhr.responseText);
        alert(msg);
      }).done(function (cart) {
        console.log('1');
        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          success: function (cart) {
            refreshCart(cart);
            //  window.setTimeout(function(){ $.fancybox.close(); $('.cart-button').click(); }, 500);
          },
        });
      });
    });
  }

  if ($('#new-products, .products').length > 0) {
    setQuickAddListener();
  }

  /**------------------------------------------------------------------------------------------------ */
  /**
   * Works on /cart page. Updates the cart item.
   */
  function changeCartItem(target, qty, note, btn) {
    btn.children('span:first-child').css('display', 'none');
    btn.children('.btn-spinner').css('display', 'block');
    if(qty<1){
      btn.closest(".omega").parent().remove();
    }
    $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      data: {
        id: target,
        properties: {'Notes for our Design Team': note},
        quantity: qty,
      },
      dataType: 'json',
    }).done(function (cart) {
      btn.children('span:first-child').css('display', 'block');

      btn.children('.btn-spinner').css('display', 'none');
      btn.addClass('btn-disabled');

      storeCartState();
      
       //RefreshCart
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        cache: false,
        success: function (cart) {
          refreshCart(cart);
        },
      });

    });
  }

  $('body').on('click','.save-checkout-changes',function (evt) {
    evt.stopPropagation();

    if ($(this).hasClass('btn-disabled')) {
      return;
    }
    var note = $(this)
      .closest('.omega')
      .find('.notes-for-our-design-team')
      .val();
    var qty = $(this).closest('.omega').find('input.quantity').val();

    var target = $(this).attr('data-key');
    changeCartItem(target, qty, note, $(this));
  });


  /**------------------------------------------------------------------------------------------------ */

  /**
   * Works on /cart page. Updates the bulk notes.
   */

  function updateBulkNotes() {
    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      data: {
        note: $(this).val(),
      },
      dataType: 'json',
    });
  }

  //Debounce function.
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
  $('.bulk_notes').on('input', debounce(updateBulkNotes, 250));

  /**------------------------------------------------------------------------------------------------ */

  /**
   * Works on /cart page. Ensures that the "Update" button is greyed out if no changes has been made.
   */
  var itemData;

  function storeCartState() {
    itemData = {};
    $('.notes-for-our-design-team').each((idx, el) => {
      var key = $(el)
        .closest('.omega')
        .find('.save-checkout-changes')
        .attr('data-key');
      var qty = $(el).closest('.omega').find('.custom-quantity');
      itemData[key + '_text'] = $(el).val();
      itemData[key + '_qty'] = qty.val();
    });
  }

  if ($('#cart_form')) {
    storeCartState();

    $('.notes-for-our-design-team').on('input', function (evt) {
      evt.preventDefault();
      var saveBtn = $(this).closest('.omega').find('.save-checkout-changes');
      if (itemData[saveBtn.attr('data-key') + '_text'] !== $(this).val()) {
        saveBtn.removeClass('btn-disabled');
      } else {
        saveBtn.addClass('btn-disabled');
      }
    });

    $('.cart_items input.custom-quantity').change(function (evt) {
      evt.preventDefault();
      var saveBtn = $(this).closest('.omega').find('.save-checkout-changes');
      if (itemData[saveBtn.attr('data-key') + '_qty'] !== $(this).val()) {
        saveBtn.removeClass('btn-disabled');
      } else {
        saveBtn.addClass('btn-disabled');
      }
    });
  }

  /**------------------------------------------------------------------------------------------------ */
  /**
   * Clear Cart button
   */

  $('.cart-page-btns').on('click', '.clear_cart', function (evt) {
    evt.preventDefault();
    $(this).children('span:first-child').css('display', 'none');

    $(this).children('.btn-spinner').css('display', 'block');

    //Remove free display offer.
    setCookie('selected-free-display', 1, -1);

    $.ajax({
      url: '/cart/clear.js',
      type: 'POST',
      dataType: 'json',
    }).done(function (cart) {
      $('.clear_cart').children('.btn-spinner').css('display', 'none');
      $('.clear_cart').children('span:first-child').css('display', 'block');
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        success: function(cart) {
          refreshCart(cart);
        }
      });
      window.location.href = '/';
    });
  });

  /**------------------------------------------------------------------------------------------------ */
  /**
   * Enables removal of individual items in slider area.
   */
  $('.mm-panel').on('click', '.remove_cart_item', function (evt) {
    window.lastClickTime = new Date().getTime();

    var cartItem = $(this).closest('li.cart_item');
    cartItem.slideUp('fast');


    setTimeout(function () {
      var key = cartItem.find('.quantity').data('key');
      var selectedDisplay = getCookie('selected-free-display');
      selectedDisplay = selectedDisplay ? JSON.parse(selectedDisplay) : {};
      if (selectedDisplay.id && selectedDisplay.id==key.split(':')[0]) {
        setCookie('selected-free-display', 1, -1);
        hidePopupFromTopAfter(0);
      }

      //remove item on /cart page
      jQuery('.item--'+key.split(':')[0]).remove();

      cartItem.remove();
      //Refreshes cart in case all items are removed.
      ajaxUpdateCart(key, 0, lastClickTime);
    }, 300);
  });

  /**------------------------------------------------------------------------------------------------ */
  /**
   * Enables removal of individual items on cart page.
   */
   
  $('body').on('click','.remove-cart-item-checkout', function (evt) {
    window.lastClickTime = new Date().getTime();


    var key = $(this).data('key').toString();

    var selectedDisplay = getCookie('selected-free-display');
    selectedDisplay = selectedDisplay ? JSON.parse(selectedDisplay) : {};
    if (selectedDisplay.id && selectedDisplay.id==key.split(':')[0]) {
      setCookie('selected-free-display', 1, -1);
      hidePopupFromTopAfter(0);
    }
    $(this)
      .closest('.item--' + key.split(':')[0])
      .remove();
    //Refreshes cart in case all items are removed.
    ajaxUpdateCart(key, 0, lastClickTime);
  });

  /**------------------------------------------------------------------------------------------------ */
  /**
   * Adds &shy to the long words so that they dont break the UI(without messing up urls, emojis and tags). And truncates the large paragraphs.
   */

  pleaseBeShyWords($('.line-item'));

  /**------------------------------------------------------------------------------------------------ */
  /**
   * Adds character counter to the notes so that the user is limited to type only certain number of characters.
   *
   */

  function addTextCounter() {
    var html = "<span class='words-left'>0/100</span>";
    $('#notes-for-our-design-team, .notes-for-our-design-team')
      .parent()
      .append($(html));
  }

  if ($('#notes-for-our-design-team, .notes-for-our-design-team').length > 0) {
    addTextCounter();
    $('#notes-for-our-design-team, .notes-for-our-design-team').on(
      'focus',
      function () {
        $(this).trigger('input');
        $(this).parent().children('.words-left').css('display', 'block');
      }
    );

    $('#notes-for-our-design-team, .notes-for-our-design-team').on(
      'blur',
      function () {
        $(this).parent().children('.words-left').css('display', 'none');
      }
    );

    $('#notes-for-our-design-team, .notes-for-our-design-team').on(
      'input',
      function (event) {
        var charLimit = 100;
        var charsLeft = charLimit - parseInt($(this).val().length);
        var target = $(this).parent().children('.words-left');
        target.html(charsLeft + '/' + charLimit);
        if (
          charsLeft < Math.ceil(charLimit / 3) &&
          charsLeft >= Math.ceil(charLimit / 10)
        ) {
          target.css('background', '#ff9800');
        } else if (charsLeft < Math.ceil(charLimit / 10)) {
          target.css('background', 'red');
        } else {
          target.css('background', 'green');
        }
        if (charsLeft <= 0) {
          $(this).val(
            $(this)
              .val()
              .slice(0, charLimit - 1)
          );
        }
      }
    );
  }

  /**------------------------------------------------------------------------------------------------ */

  /**
   * Adds arrow increment buttons to input textfield.
   */
  function styleNumberInput(siblingNode) {
    //Add input nav button.
    siblingNode.after(
      $(
        '<div class="quantity-arrow-nav"><button class="quantity-button quantity-up">&#9650;</button><button class="quantity-button quantity-down">&#9660;</button></div><div class="clearfix"></div>'
      )
      
    );
    //Attach input nav listener.
  }

  function attachQtyListeners(parentNode) {
    parentNode.off('click', '.quantity-up');
    parentNode.off('click', '.quantity-down');
    parentNode.off('click', '.custom-quantity');

    parentNode.on('click', '.quantity-up', function (event) {
      event.stopPropagation();
      event.preventDefault();

      var input = $(this).closest('.qty-wrapper, .custom-quantity-selector').find('.custom-quantity');

      // Determine step/min based on class
      var step = getStep(input);
      var min = parseInt(input.attr('min')) || step;
      var max = parseInt(input.attr('max')) || Number.MAX_SAFE_INTEGER;

      var oldValue = parseFloat(input.val()) || min;
      var newVal = oldValue >= max ? oldValue : oldValue + step;

      input.val(newVal).trigger('change');
    });

    parentNode.on('click', '.quantity-down', function (event) {
      event.stopPropagation();
      event.preventDefault();

      var input = $(this).closest('.qty-wrapper, .custom-quantity-selector').find('.custom-quantity');

      var step = getStep(input);
      var min = parseInt(input.attr('min')) || step;
      var max = parseInt(input.attr('max')) || Number.MAX_SAFE_INTEGER;

      var oldValue = parseFloat(input.val()) || min;
      var newVal = oldValue <= min ? oldValue : oldValue - step;

      input.val(newVal).trigger('change');
    });

    parentNode.on('input change', '.custom-quantity:not(.free-product)', function (event) {
      event.stopPropagation();
      event.preventDefault();

      var inputRef = $(this);
      var val = parseInt(inputRef.val()) || 0;

      var step = getStep(inputRef);
      var min = step; // base min according to rule

      if (val < min && val > 0) {
        inputRef
          .attr('title', 'Should be at least ' + min)
          .tooltip('fixTitle')
          .tooltip('show');
      } else if (val % step !== 0) {
        inputRef
          .attr('title', 'Quantity should be in multiple of ' + step + '.')
          .tooltip('fixTitle')
          .tooltip('show');
      } else {
        inputRef.tooltip('hide');

        // subtotal update logic (reuse your existing part)
        var subtotalEl = inputRef
          .closest('.reorder-item-wrapper')
          .find('.item-subtotal span');
        if (subtotalEl.length) {
          var price = val * parseFloat(inputRef.data('price'));
          subtotalEl.html('$' + price.toFixed(2));
        }

        var totalItems = 0;
        var totalPrice = 0;
        $('.custom-quantity').each((idx, element) => {
          var qty = parseInt($(element).val()) || 0;
          totalItems += qty;
          totalPrice += qty * parseFloat($(element).data('price') || 0);
        });
        totalPrice = totalPrice.toFixed(2);
        $('.add-reorder-items span:nth-child(2)').html('(' + totalItems + ' items)');
        $('.reorder-total-bar span').html('Subtotal: $' + totalPrice);
      }
    });

    parentNode.on('input change', '.free-product', function (event) {
      event.stopPropagation();
      event.preventDefault();
      var inputRef = $(this);
      inputRef
        .attr('title', 'Quantity cannot be changed for free item.')
        .tooltip('fixTitle')
        .tooltip('show');
    });

    // Helper: decide step based on class
    function getStep(input) {
      if (input.hasClass('sticker') || input.hasClass('acrylic') || input.hasClass('wood')) {
        return 25;
      }
      return parseInt(input.attr('step')) || 1; // fallback
    }
  }
  //Init tooltip.
  $('[data-toggle="tooltip"]').tooltip();

  styleNumberInput($('.custom-quantity'));

  attachQtyListeners($('#product-form'));
  attachQtyListeners($('#cart_form'));
  /**------------------------------------------------------------------------------------------------ */
  /**
   * For reorder page.
   */

  /**
   * Loads items on reorder page.
   */

  var reorderOffset = 0;
  var reorderLength = 24;
  var reorderItemsCache = [];

  if (window.reorderData) {
    reorderItemsCache = [
      ...new Set(
        window.reorderData
          .filter((item) => (item.title ? true : false))
          .map((item) => JSON.stringify(item))
      ),
    ];
    reorderItemsCache = reorderItemsCache.map((item) => {
      item = JSON.parse(item);

      return item;
    });
  }

  var archivedItems = [];
  var archiveMetafieldId = null;

  if (archivedItems.length < 1 && window.location.pathname.includes('reorder')) {
    jQuery
      .ajax({
        url: '/apps/stickerpack-custom/api/archive',
        type: 'GET',
        data: {
          customerId: window.customerId,
        },
        dataType: 'json',
      })
      .done((response) => {
        try {
          var archive = response.data.customer.metafields.edges[0].node;
          archivedItems = JSON.parse(archive.value);
          archiveMetafieldId = archive.id ? archive.id : null;
        } catch {
          //Nothing here.
        }
        jQuery('.reorder-item-wrapper').css('display', 'block');
        archivedItems.forEach((itemId) => {
          jQuery('.item--' + itemId).css('display', 'none');
        });
        jQuery('.sticker-loader').css('display', 'none');
      })
      // 2026-09-04 fix: if the archive service is unreachable, still show the items.
      .fail(function (xhr) {
        console.error('stickerpack-custom archive call failed', xhr.status);
        jQuery('.reorder-item-wrapper').css('display', 'block');
        jQuery('.sticker-loader').css('display', 'none');
      });
  }

  $('.search-reorder').on(
    'input',
    debounce(function () {
      $('.reorder_items')
        .children()
        .each((idx, item) => {
          var title = $(item).find('.omega p a').html();
          if (!title) {
            return;
          }
          var searchVal = $('.search-reorder').val().toLowerCase();
          if (title.trim(' ').toLowerCase().search(searchVal) >= 0) {
            $(item).css('display', 'block');
          } else {
            $(item).css('display', 'none');
          }
        });
    }, 300)
  );

  $('.add-reorder-items').on('click', function () {
    var items = [];
    $('.custom-quantity').each(function () {
      var id = $(this).data('variant-id');
      var qty = $(this).val();
      var properties = {
        'Notes for our Design Team': $(this)
          .closest('.reorder-item-wrapper')
          .find('.reorder-notes span')
          .html(),
      };
      var size = $(this).data('variant-type');
      if (qty > 0) {
        items = [
          ...items,
          {id: id, quantity: qty, properties: properties, 'option-0': size},
        ];
      }
    });
    if (items.length > 0) {
      $(this).children('span').css('display', 'none');

      $(this).children('.btn-spinner').css('display', 'inline');

      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        data: {
          items: items,
        },
        dataType: 'json',
      }).fail(function (xhr) {
        var msg = 'Could not add items to cart.';
        try { msg = JSON.parse(xhr.responseText).description || msg; } catch (e) {}
        console.error('Reorder /cart/add.js failed', xhr.status, xhr.responseText);
        $('.add-reorder-items').children('span').css('display', 'inline');
        $('.add-reorder-items').children('.btn-spinner').css('display', 'none');
        alert(msg);
      }).done(function (cart) {
        console.log('2');
        $('.add-reorder-items').children('span').css('display', 'inline');
        $('.add-reorder-items').children('.btn-spinner').css('display', 'none');
  console.log('hisss');
        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          success: function (cart) {
            refreshCart(cart);
          },
        });
      });
    }
  });

  function addArchiveListener() {
    var id = $(this).data('id');
    $('.item--' + id).remove();
    archivedItems = [...archivedItems, id];
    var archiveData = JSON.stringify(archivedItems);
    var data = {
      customerId: window.customerId,
      archiveData: archiveData,
    };
    if (archiveMetafieldId) {
      data.metaFieldId = archiveMetafieldId;
    }
    jQuery.ajax({
      url: '/apps/stickerpack-custom/api/archive',
      type: 'POST',
      data: data,
      dataType: 'json',
    });
  }

  $('.reorder-main-wrapper').on(
    'click',
    '.archive-item .action_button',
    addArchiveListener
  );

  attachQtyListeners($('.reorder-main-wrapper'));

  pleaseBeShyWords($('.reorder-notes'));

  /**------------------------------------------------------------------------------------------------ */
  /**
   * Pop up from top
   */

  var popupShown = false;
  function initPopupFromTop() {
    popupShown = true;

    var selectedDisplay = getCookie('selected-free-display');

    var popup = jQuery('.popup-from-top:not(.popup-disabled)'),
      hideAfter = selectedDisplay
        ? 999999999
        : parseInt(popup.data('hide-after')) * 1000,
      delay = selectedDisplay ? 50 : parseInt(popup.data('delay')) * 1000,
      delay = delay === 0 ? 50 : delay;

    showPopupFromTopAfter(delay);
    hidePopupFromTopAfter(hideAfter);
    jQuery('.display-offer-dismiss').click(hidePopupFromTopAfter);
  }

  function showPopupFromTopAfter(delay = 0) {
    var popup = jQuery('.popup-from-top:not(.popup-disabled)');
    setTimeout(function () {
      popup.css({top: '0px'});
      jQuery('#header, .default-header')
        .addClass('popup-shift-sibling');

      jQuery('.push_content_down .slideshow-section')
        .addClass('popup-shift-sibling');
      jQuery('.main_content_area').addClass("tpopup_open");
    }, delay);
    
  }

  function hidePopupFromTopAfter(hideAfter = 0) {
    var popup = jQuery('.popup-from-top:not(.popup-disabled)'),
      popupAnimationSpeed = parseInt(popup.data('popup-animation-speed'));
    setTimeout(function () {
      popup.css({top: '-40px'});
      jQuery('.mobile-header, .default-header')
        .removeClass('popup-shift-sibling');

      jQuery('.push_content_down .slideshow-section')
        .removeClass('popup-shift-sibling');
      jQuery('.main_content_area').removeClass("tpopup_open");
    }, hideAfter);
  }
function delete_my_cookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
  function initDisplaySelection() {
    var selectionNode = jQuery('<div class="selected-display-item"></div>');

    jQuery('.stickerpack-display-image')
      .parent()
      .addClass('display-offer-hover');

    jQuery('.stickerpack-display-image').click(function () {
      jQuery(this).parent().append(selectionNode);
      var variantId = jQuery(this).parent().data('variant-id'),
        maxLarge = jQuery(this).parent().data('max-large'),
        maxSmall = jQuery(this).parent().data('max-small'),
        title = jQuery(this).parent().children('h2').html().trim();

      jQuery('.display-offer-fill').removeClass('btn-disabled');

      var itemData = JSON.stringify({
        id: variantId,
        quantity: 1,
        title: title,
        maxLarge: maxLarge,
        maxSmall: maxSmall,
      });

      setCookie('selected-free-display', itemData, 1);
    });

    jQuery('body').on(
      'click',
      '.display-offer-fill:not(.btn-disabled)',
      function () {
        window.location = '/';
      }
    );
    jQuery('.clear-displays').on("click",function (){
      delete_my_cookie("selected-free-display");
      location.reload();
    });
  }

  initDisplaySelection();

  //----------
    function initFreeDisplayOffer() {
    document.querySelector('body').addEventListener('cartChanged', function(event) {
      const items = event.cart.items;

      const selectedDisplayCookie = getCookie('selected-free-display');
      if (!selectedDisplayCookie) {
        removeAllFreeDisplayItemsFromCart(items);
        return;
      }

      const selectedDisplay = JSON.parse(selectedDisplayCookie);

      // Always get these from cookie, not DOM
      const maxLarge = parseInt(selectedDisplay.maxLarge) || 0;
      const maxSmall = parseInt(selectedDisplay.maxSmall) || 0;
      const productType = selectedDisplay.productType || '';

      const spaceLeftMessage = jQuery('.free_display_added');
      if (!spaceLeftMessage[0]) return;

      // Disable qty manipulation only if element exists on this page
      if (document.querySelector('[data-variant-id="' + selectedDisplay.id + '"]')) {
        styleFreeDisplayCartSliderItem(selectedDisplay);
      }

      let small = 0, large = 0;
      items.forEach(item => {
        const slotSize = Math.round(parseInt(item.quantity) / 50);
        // 2026-09-04 fix: variant_title is now "Small / Sticker" etc. Use the first option (Print Size).
        const size = (item.variant_options && item.variant_options[0]) || (item.variant_title || '').split('/')[0].trim();
        if (size === 'Small') small += slotSize;
        else if (size === 'Large') large += slotSize;
      });

      const spaceLeftForLarge = Math.max(maxLarge - large, 0);
      const spaceLeftForSmall = Math.max(maxSmall - small, 0);

      // 🔹 Console log for debugging
      console.log('Space left Large (X):', spaceLeftForLarge);
      console.log('Space left Small (Y):', spaceLeftForSmall);
      console.log('Product Type:', productType);

      if (spaceLeftForLarge < 1 && spaceLeftForSmall < 1) {
        // Display full
        spaceLeftMessage.addClass('d-none');
        spaceLeftMessage.next().removeClass('d-none');
        jQuery('.display-offer-update').removeClass('d-none');
        jQuery('.display-offer-checkout').removeClass('d-none');

        const freeItems = items.filter(i => i.title.includes('Free') && i.title.includes('Sided'));
        if (freeItems.length > 0 && !jQuery('.item--' + selectedDisplay.id)[0]) {
          addItemsOnCartPage(freeItems[0]);
        } else if (!jQuery('.item--' + selectedDisplay.id)[0]) {
          updateFreeDisplayQty(selectedDisplay.id, parseInt(selectedDisplay.quantity));
        }
      } else {
        // 🔹 Update message dynamically starting from a clean template
        let baseMessage = spaceLeftMessage.data('template') || spaceLeftMessage.html().trim();

        // Save the template if not already saved
        if (!spaceLeftMessage.data('template')) {
          spaceLeftMessage.data('template', baseMessage);
        }

        // Replace X and Y
        baseMessage = baseMessage.replace(/^[X]|^[\d]+/, spaceLeftForLarge);
        baseMessage = baseMessage.replace(/[\s]([Y]|[\d]+)/, ' ' + spaceLeftForSmall);

        // Replace "designs" → "Sticker Designs" or "Magnet Designs" ONLY ONCE
        if (productType) {
          const prodTypeCapitalized = productType.charAt(0).toUpperCase() + productType.slice(1);
          // 🔹 Match only lowercase "designs" as a whole word
          baseMessage = baseMessage.replace(/\bdesigns\b/g, prodTypeCapitalized + ' Designs');
        }

        // Update the message
        spaceLeftMessage.html(baseMessage);

        // Show/hide UI states
        spaceLeftMessage.removeClass('d-none');
        jQuery('.remove-free-display').removeClass('d-none');
        setTimeout(() => jQuery(document).find('.clear-displays').removeClass('d-none'), 1000);
        spaceLeftMessage.next().addClass('d-none');
        jQuery('.display-offer-update').addClass('d-none');
        jQuery('.display-offer-checkout').addClass('d-none');

        removeAllFreeDisplayItemsFromCart(items);
      }

      // Show popup once if not already shown
      if (!popupShown && selectedDisplay) {
        jQuery('.free-display-offer-text').addClass('d-none');
        jQuery('.display-offer-yes').addClass('d-none');
        jQuery('.display-offer-dismiss').addClass('d-none');
        initPopupFromTop();
      }
    });
  }


  if( screen.width > 798){
    initFreeDisplayOffer();
  }


  function styleFreeDisplayCartPageItem() {
    var selectedDisplay = getCookie('selected-free-display');
    selectedDisplay = selectedDisplay ? JSON.parse(selectedDisplay) : {};
    var displayCartItem = jQuery('.item--' + selectedDisplay.id);
    if (displayCartItem[0]) {
      displayCartItem.find('.price_total .money').html('Free');
      displayCartItem
        .find('.custom-quantity')
        .attr('readonly', true)
        .attr('min', '1')
        .attr('max', '1')
        .attr('step', '1')
        .attr('title', 'Only 1 free display allowed')
        .addClass('free-product');
      displayCartItem
        .find('.remove-cart-item-checkout');
      displayCartItem.find('.omega p:first-child a').removeAttr('href');
      displayCartItem.find('.alpha a').removeAttr('href');
    }
  }

  function styleFreeDisplayCartSliderItem(selectedDisplay) {
    var sliderCartItem = jQuery('[data-id="' + selectedDisplay.id + '"]');
    if (sliderCartItem) {
      sliderCartItem
        .attr('readonly', true)
        .attr('max', '1')
        .attr('step', '1')
        .attr('min', '1')
        .attr('step', '1');
      sliderCartItem.next().addClass('disabled');
      sliderCartItem.prev().addClass('disabled');
      sliderCartItem
        .closest('.cart_item')
        .find('.remove_cart_item');
    }
  }

  styleFreeDisplayCartPageItem();

  function updateFreeDisplayQty(id, qty) {
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      data: {
        form_type: 'product',
        id: id,
        quantity: qty,
      },
      dataType: 'json',
    }).done(function (item) {
      console.log('jjj');
      //If the items werere added on the cart page and display got filled completely, cart page items will be reloaded.
      if(qty!==0){
        addItemsOnCartPage(item);
      }

      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        cache: false,
        success: function (cart) {
          refreshCart(cart, {dispatchCartEvent: false});
        },
      });
    });
  }

  function removeAllFreeDisplayItemsFromCart(items=[]) {
    new Promise(function (resolve, reject) {
    
      var itemsToBeRemoved =items.length>0? items.filter(
        (item) => item.title.includes('Free') && item.title.includes('Sided')
      ).map(item=>item.key) :$('.cart_item').filter((idx,cartItem)=>{
          var itemInfo = $(cartItem).find('.item_info');
          return itemInfo.html().includes('Sided') && itemInfo.html().includes('Free');
        }).map((idx,cartItem)=>$(cartItem).find('input').data('key')).toArray() ; 

      var itemsToBeRemovedLength = itemsToBeRemoved.length;
      if (itemsToBeRemovedLength > 0) {
        itemsToBeRemoved.forEach((key) => {
          $.ajax({
            url: '/cart/change.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: {
              id: key,
              quantity: 0,
            },
            success: function (data) {
              itemsToBeRemovedLength--;
              jQuery(".item--"+key.split(':')[0]).remove();
              if (itemsToBeRemovedLength < 1) {
                resolve();
              }
            },
          });
        });
      } else {
        reject();
      }
    }).then(() => {
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        cache: false,
        success: function (cart) {
          refreshCart(cart, {dispatchCartEvent: false});
        },
      });
    },()=>{});
  }

  function addItemsOnCartPage(item) {
    var cartItems = jQuery('.cart_items');
    if(jQuery(".item--"+item.id)[0] || !cartItems[0]){
      return;
    }
    var item = '<div class="item--'+item.id+'">\
      <div class="col-sm-6 col-xs-12 alpha">\
        <a title="Free 2 Sided Counter" class="cart_page_image">\
          <img alt="Free 2 Sided Counter" class="lazyload--fade-in lazyautosizes lazyloaded" style="max-width:1000px" data-sizes="auto"  sizes="305px"  src="'+item.image+'">\
        </a>\
      </div>\
      <div class="col-sm-6 col-xs-12 omega">\
        <p>\
          <a>\
            '+item.title+'\
          </a>\
        </p>\
        <p class="price_total">\
          <span class="money">Free</span>\
        </p>\
        <p id="quantity_1" class="qty-wrapper">\
          <label for="updates_'+item.id+'" class="quantity_label">Quantity:</label>\
          <input type="number" min="1" step="1" size="3" maxlength="3" class="quantity custom-quantity free-product" id="" value="1" data-line-id="1" readonly="readonly" max="1" title="Only 1 free display allowed">\
        </p>\
        <p class="line-item-property__field">\
          <label for="notes-for-our-design-team">Notes for our Design Team (optional):</label>\
          <textarea class="notes-for-our-design-team" name="properties[Notes for our Design Team]" value=""></textarea>\
        <span class="words-left">0/100</span></p>\
        <div class="save-changes-wrapper">\
          <a class="action_button save-checkout-changes btn-disabled" data-key="'+item.id+'"><span>Update</span><span class="btn-spinner"><img src="//stickerpack.com/cdn/shop/t/52/assets/loader-sm.svg?v=28076881541690525881790100737" alt="" /></span></a>\
            <a class="action_button remove-cart-item-checkout" data-key="'+item.id+'"><span>Remove</span><span class="btn-spinner"><img src="//stickerpack.com/cdn/shop/t/52/assets/loader-sm.svg?v=28076881541690525881790100737" alt="" /></span></a>\
        </div>\
      </div>\
      <br class="clear">\
      <br class="clear">\
    </div>';


    //Filter those items which haven't been added already.

    newCartItem = jQuery(item);
    cartItems.children('.cart-page-btns').after(newCartItem);
    styleNumberInput(newCartItem.find('.custom-quantity'));
    attachQtyListeners($('#cart_form'));

    //Make some style changes to free display item on cart page, disable qty manipulation, replace the 0 price tag with 'Free', and add suitable popup
    styleFreeDisplayCartPageItem();
  
  }

  jQuery('.remove-free-display').click(function () {
    var selectedDisplay = getCookie('selected-free-display');
    selectedDisplay = selectedDisplay ? JSON.parse(selectedDisplay) : {};
    if (selectedDisplay.id) {
      setCookie('selected-free-display', 1, -1);
      jQuery('.item--'+selectedDisplay.id).remove();
    }
    hidePopupFromTopAfter(0);
    removeAllFreeDisplayItemsFromCart();
  });

  //RefreshCart
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    cache: false,
    success: function (cart) {
      refreshCart(cart);
    },
  });




});



  /** Fetches non cached content so that content like collection products are random on each page load.
   * 
  */

  (function fetchRandomContentPages(){
    const selectors = {
      randomContent: '.randomized-content',
      lazyload: '.lazyload'
    };

    var randomizedContent = $(selectors.randomContent);
    if(randomizedContent[0]){
      $.ajax({
        url: randomizedContent[0].dataset.contentUrl +'?q=' + Math.random(), //random query to disable the cache
        cache: false,
        success: function (response) {
          var newContent = $($(response).find(selectors.randomContent)[0].outerHTML);
          newContent.find(selectors.lazyload).each(function(idx, node){
            if(node.dataset.srcDisabled){
              node.dataset.src = node.dataset.srcDisabled;
              node.dataset.srcset = node.dataset.srcsetDisabled;
              delete node.dataset.srcDisabled;
              delete node.dataset.srcsetDisabled;
            }
          });

          randomizedContent.replaceWith(newContent);
        },
      });
    }
  })();